<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>


    <!--    점검대상-->
<!--    <vs-row class="mt-6">-->
<!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
<!--        <h5>-->
<!--          <i class="dot"></i> 점검대상-->
<!--        </h5>-->
<!--      </vs-col>-->
<!--    </vs-row>-->

<!--    <div class="gap-x-6 gap-y-4 mt-4">-->
<!--      <span v-if="isPrint"> {{form.inspectionTitle}} </span>-->
<!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
<!--        <vs-checkbox-->
<!--          class="mr-1 mb-2"-->
<!--          :readonly="board.readonly">-->
<!--          {{form.inspectionTitle}}-->
<!--        </vs-checkbox>-->
<!--      </div>-->
<!--    </div>-->


    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      :is-note="true"
      @update-list-check="updateListCheck"
      @update-note="updateListNote"
    />


    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionTitle:'급식',
      form: {
        inspectionTitle:'급식',
        stdInfo: { },
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: []
      },
    }
  },
  computed: {
    inspectTable () {
      return  [
        {
          id: 1,
          label: '바닥의 물·기름·물때 등으로 인해 미끄러질 위험 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 2,
          label: '통로 확보 및 통행로나 바닥에 호스, 물품 적재·방치 여부 ',
          is_checked: '',
          note: '',
        },
        {
          id: 3,
          label: '장애물(문턱·배관·패인곳 및 돌출부 등)로 인해 넘어질 위험 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 4,
          label: '조리장·계단·통로에 적정한 조명 설치 여부 ',
          is_checked: '',
          note: '',
        },
        {
          id: 5,
          label: '계단에 난간 설치, 답단 끝에 미끄러짐 방지 조치 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 6,
          label: '미끄러짐 방지 장화 등 보호구 착용 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 7,
          label: '청소 후 트렌치 덮개를 원상태로 덮어 놓았는지 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 8,
          label: '왁스, 물청소 등으로 넘어짐 위험장소에 “미끄러짐표지” 부착 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 9,
          label: '문은 쉽게 열고 닫을 수 있는 구조를 유지하고 있는지 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 10,
          label: '재료 운반대차 및 배식차에 끼일 위험 여부 ',
          is_checked: '',
          note: '',
        },
        {
          id: 11,
          label: '양념재료(마늘·파·양파 등) 분쇄기·절단기에 말려들 위험 여부 ',
          is_checked: '',
          note: '',
        },
        {
          id: 12,
          label: '기계의 회전체(벨트·체인·회전날개 등)에 방호덮개 설치 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 13,
          label: '리프트, 덤웨이터의 안전한 사용 여부 \n- 사람 탑승금지 조치, (출입)문이 열린 상태에서는 동작이 안 되도록 조치되어 있는지 여부\n- 사용중량, 경고표지 부착 여부 등 ',
          is_checked: '',
          note: '',
        },
        {
          id: 14,
          label: '절단기·분쇄기 칼날 부위에 베임방지용 덮개 설치 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 15,
          label: '칼날 등에 베일 위험을 방지하기 위한 조치 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 16,
          label: '칼 용도 외 사용 여부 (김치포장 끈 제거, 캔 뚜껑 제거, 식용류 뚜껑 제거 등)',
          is_checked: '',
          note: '',
        },
        {
          id: 17,
          label: '식자재 운반카트의 바퀴 고정장치(stopper) 정상작동 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 18,
          label: '부딪힘 사고 유형별 예방 확인\n- 선반 등 돌출부 부딪힘\n- 이동 중인 급식카트와 부딪힘\n- 이동 중 시야 미확보 부딪힘\n- 식기세척, 청소 후 일어서다가 물체와 부딪힘\n- 의자, 작업발판 등 위에서 내려오다가 미끄러져 부딪힘',
          is_checked: '',
          note: '',
        },
        {
          id: 19,
          label: '전기 기계·기구에 감전 예방용 접지 상태 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 20,
          label: '누전차단기 설치 및 월1회 이상 동작 점검 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 21,
          label: '전선의 노후화 또는 피복손상, 심하게 구부러짐 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 22,
          label: '가스누출감지기, 경보기가 정상적으로 작동하는지 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 23,
          label: '가스공급배관에서 가스가 누출되고 있지 않은지 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 24,
          label: '급식실 작업장 환기는 충분히 실시하고 있는지 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 25,
          label: '환기 방법',
          is_checked: '',
          note: '',
        },
        {
          id: 26,
          label: '환기장치 설치 및 조리 시 사용여부',
          is_checked: '',
          note: '',
        },
        {
          id: 27,
          label: '환기장치 작동 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 28,
          label: '급식실 후드청소 주기',
          is_checked: '',
          note: '',
        },
        {
          id: 29,
          label: '급식실 위치',
          is_checked: '',
          note: '',
        },
        {
          id: 30,
          label: '급식실에 적합한 소화기 비치 및 정상작동 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 31,
          label: '국솥 등에 한꺼번에 많은 양의 식자재를 넣고 있지 않은가',
          is_checked: '',
          note: '',
        },
        {
          id: 32,
          label: '뜨거운 물, 국 등이 들어있는 회전식 국솥 핸들고정 장치가 정상적으로 고정되어 있는지 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 33,
          label: '자외선 살균기, 전격살충기 등 램프 적정선정 및 정상작동 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 34,
          label: '기타 각종 위험요인으로부터 근로자 보호조치 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 35,
          label: '고온 스팀 사용장소에 “고온 경고” 또는 “화상주의” 표지 게시 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 36,
          label: '뜨거운 용기 취급시 방열장갑 또는 보조집게 사용여부',
          is_checked: '',
          note: '',
        },
        {
          id: 37,
          label: '조리실 등 고온다습하고 환기가 불충분한 장소에 적정한 환기, 통풍, 냉방시설 설치 및 관리여부',
          is_checked: '',
          note: '',
        },
        {
          id: 38,
          label: '물질안전보건자료(MSDS)의 게시(비치) 및 교육 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 39,
          label: '취급용기 및 포장에 MSDS 경고표지 부착 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 40,
          label: '세제, 청소제 등 화학물질 취급시 고무장갑 등 적정 보호장구 착용여부',
          is_checked: '',
          note: '',
        },
        {
          id: 41,
          label: '근골격계부담작업 유해요인조사 실시여부',
          is_checked: '',
          note: '',
        },
        {
          id: 42,
          label: '근골격계질환 예방을 위해 인력작업 보조설비 및 편의설비 등 작업환경 개선여부',
          is_checked: '',
          note: '',
        },
        {
          id: 43,
          label: '근골격계부담작업 종사자에 대한 유해성 주지 (교육 등) 적정성',
          is_checked: '',
          note: '',
        },
        {
          id: 44,
          label: '중량물 안내포스터 부착 유무 - 5kg 이상 물체를 중량물로 취급',
          is_checked: '',
          note: '',
        },
        {
          id: 45,
          label: '작업 전·후 스트레칭 실시 및 적정 휴식시간 배분 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 46,
          label: '운반작업 시 적정한 양 운반, 2인 1조작업 또는 이동대차 등 운반보조도구 사용여부',
          is_checked: '',
          note: '',
        },
      ]

    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
    updateListNote (indexRows, text) {
      this.form.inspectList[indexRows].note = text
    }
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
